import request from '@/utils/request';
//分页查询大连会员数据
export function queryIncomeStatementList(param) {
  return request('/sales-finance-report/queryIncomeStatementList', {
    method: 'POST',
    data: param,
  });
}
//获取等级列表
export function getLevels() {
  return request('/config/queryLevels', {
    method: 'GET',
  });
}
